export default "__VITE_ASSET__COAXFsDY__"